import axios from "axios";

export default {
  actions: {
    loadTrainScheduleParametersByBaseType: (context, baseTypeCode) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/train-schedule-parameters/by-base-type/" + baseTypeCode)
        .then((response) => response.data)
        .catch((err) => err.response);
    },
    loadTrainScheduleParametersByTrainNumber: (context, trainNumber) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/train-schedule-parameters/by-train-number/" + trainNumber)
        .then((response) => response.data)
        .catch((err) => err.response);
    },
    createTrainScheduleParameter: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-schedule-parameters", request, {})
        .then((response) => response.data)
        .catch((err) => err.response);
    },
    updateTrainScheduleParameter: (context, request) => {
      return axios
        .put(context.getters.getMcServiceUrl + "/train-schedule-parameters", request, {})
        .then((response) => response.data)
        .catch((err) => err.response);
    },
    deleteTrainScheduleParameter: (context, id) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-schedule-parameters/" + id)
        .then((response) => response.data)
        .catch((err) => err.response);
    },
  },
};
